var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 98.68 98.99",
    style: {
      enableBackground: "new 0 0 98.68 98.99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000102522650101632677290000001565585481388534708_);}\r\n\t.st2{fill:url(#SVGID_00000166668718076249747030000015084413982284929154_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.0098,
    y1: 15.2778,
    x2: 82.9093,
    y2: 88.3113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.55,63.58c0.61,0,1.22-0.16,1.79-0.47l20.38-11.51V25.3c0-2-1.61-3.61-3.61-3.61 c-2.01,0-3.62,1.61-3.62,3.61v22.11l-16.7,9.43c-1.75,0.98-2.36,3.18-1.38,4.92C28.06,62.92,29.27,63.58,30.55,63.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128466916020197613770000001519894211463872923_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.1631,
    y1: 14.8933,
    x2: 76.3651,
    y2: 81.2768
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.01
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000128466916020197613770000001519894211463872923_)"
    },
    cx: 48.32,
    cy: 48.15,
    r: 45
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179610517620673888320000005900829488165098650_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.4716,
    y1: 13.8988,
    x2: 84.3711,
    y2: 86.9323
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179610517620673888320000005900829488165098650_)"
    },
    d: "M83.8,14.86 c-3.95-3.96-8.51-7.17-13.54-9.56c-4.83-2.31-10.02-3.8-15.37-4.45C44.18-0.43,33.22,1.88,24.01,7.35 c-0.57,0.33-1.14,0.71-1.71,1.06l0.43-3.69c0.23-1.98-1.18-3.78-3.16-4.02c-1.98-0.24-3.79,1.18-4.03,3.16l-1.96,16.37h4.07 l12.89-0.02c2,0,3.61-1.63,3.61-3.61c0-2-1.63-3.61-3.61-3.61h-1.91c16.31-9.11,36.76-6.33,50.06,6.94 c7.92,7.9,12.26,18.39,12.26,29.54c0,11.15-4.36,21.66-12.26,29.54c-7.92,7.9-18.43,12.23-29.61,12.23 c-11.18,0-21.71-4.29-29.63-12.19C13.14,72.76,9.07,64.82,7.7,56.06c-0.31-1.96-2.16-3.31-4.15-3c-1.97,0.31-3.32,2.15-3.01,4.14 c1.63,10.27,6.39,19.58,13.77,26.95c9.27,9.25,21.61,14.35,34.74,14.35s25.47-5.1,34.74-14.35c9.27-9.25,14.38-21.56,14.38-34.65 C98.18,36.4,93.09,24.11,83.8,14.86z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.61a03c4ba2848e8acf82b55601257340.svg";
export { ForwardRef as ReactComponent };